<template>
<v-app>
    <v-content>
        Нема доступу
    </v-content>
</v-app>
</template>

<script>
export default {
    data: () => ({}),
    props: {},
    methods: {}
}
</script>
